export enum ModalType {
  Calculation = "calculation",
}
